/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
export type TVShowEpisodeState = "available" | "hidden" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type EpgItem_epgitem$ref: FragmentReference;
export type EpgItem_epgitem = {|
  +id: string,
  +title: ?string,
  +subtitle: ?string,
  +description: ?string,
  +shortDescription: ?string,
  +startDate: ?string,
  +endDate: ?string,
  +liveShow: ?boolean,
  +surdo: ?boolean,
  +show: ?{|
    +id: string
  |},
  +videoFile: ?{|
    +id: string,
    +filename: ?string,
  |},
  +preview: ?{|
    +id: string,
    +filename: ?string,
  |},
  +topics: ?$ReadOnlyArray<?{|
    +id: string,
    +name: ?string,
  |}>,
  +state: TVShowEpisodeState,
  +$refType: EpgItem_epgitem$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = [
  v0,
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "filename",
    "args": null,
    "storageKey": null
  }
];
return {
  "kind": "Fragment",
  "name": "EpgItem_epgitem",
  "type": "TVShowEpisode",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    v0,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "subtitle",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "description",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "shortDescription",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "startDate",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endDate",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "liveShow",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "surdo",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "show",
      "storageKey": null,
      "args": null,
      "concreteType": "TVShow",
      "plural": false,
      "selections": [
        v0
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "videoFile",
      "storageKey": null,
      "args": null,
      "concreteType": "MediaFile",
      "plural": false,
      "selections": v1
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "preview",
      "storageKey": null,
      "args": null,
      "concreteType": "MediaFile",
      "plural": false,
      "selections": v1
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "topics",
      "storageKey": null,
      "args": null,
      "concreteType": "Topic",
      "plural": true,
      "selections": [
        v0,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "state",
      "args": null,
      "storageKey": null
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a8476c57ed082e69899b16314fc421b9';
module.exports = node;



// WEBPACK FOOTER //
// src/components/epg/__generated__/EpgItem_epgitem.graphql.js